import styled from 'styled-components';

import colors from '../../../../styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const LocationListItem = styled.div`
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid ${colors.neutralForm};
	padding-bottom: 0.75rem;
	margin-bottom: 0.75rem;

	& > * + * {
		margin-left: 1rem;
	}

	&:last-child {
		border-bottom: none;
		padding-bottom: 0.5rem;
		margin-bottom: 0;
	}

	.info-wrapper p {
		margin-top: 0.125rem;
		color: ${colors.neutralText};
	}
`;

export const Form = styled.form`
	position: relative;

	.close-button {
		position: absolute;
		top: 1rem;
		right: 1rem;
		color: ${colors.neutralButton};
	}

	.modal-content {
		display: grid;
		grid-template-columns: 1fr;
		gap: 2rem;
		margin: 0 auto 2rem;
		max-width: 41.25rem;
		padding: 3rem 1rem 1rem;

		&__header {
			display: grid;
			grid-template-columns: 1fr;
			gap: 0.5rem;
			margin-bottom: 1rem;
		}

		&__section {
			display: grid;
			grid-template-columns: 1fr;
			gap: 1.5rem;
			width: 100%;
			max-width: 25rem;
			margin: 0 auto;

			.checkbox-wrapper {
				display: grid;
				grid-template-columns: 1fr;
				gap: 1rem;
				position: relative;

				.field-label {
					color: ${colors.neutralText};

					&.with-error {
						color: ${colors.stateDanger};
					}
				}

				.checkbox-field {
					display: flex;
					align-items: center;

					& > * + * {
						padding-left: 0.75rem;
					}

					label {
						font-size: 1rem;
						line-height: 1.375rem;
						font-weight: 400;
						color: black;
						cursor: pointer;
					}
				}
			}
		}

		.error-wrapper {
			position: absolute;
			bottom: -1.25rem;
			color: ${colors.stateDanger};
		}
	}

	.modal-footer {
		display: flex;
		justify-content: flex-end;
		padding: 1.5rem;
		border-top: 1px solid ${colors.neutralForm};
	}
`;
